import { required, minLength } from 'vuelidate/lib/validators'

import { phoneValidator } from '@/utils/validations/validations'
const requiredMsg = 'Обязательное поле'

export default vars => {
  const rules = {
    login: {
      required: {
        validator: required,
        message: required
      }
    },
    email: {
      required: {
        validator: required,
        message: required
      }
    },
    phone: {
      required: {
        validator: required,
        message: required
      },
      phone: (() => {
        // if (!vars.isNew) {
        //   return false
        // }
        return {
          validator: phoneValidator,
          message: 'Введите корректный номер телефона'
        }
      })()
    },
    password: {
      minLength: {
        validator: minLength(6),
        message: 'Минимальная длина 6 символов'
      }
    }
  }
  if (vars.isNew) {
    rules.password = {
      required: {
        validator: required,
        message: requiredMsg
      },
      minLength: {
        validator: minLength(6),
        message: 'Минимальная длина 6 символов'
      }
    }
  }
  return rules
}
